enum Web {
  SINGLE_SIGN_ON = 'web-react-sso',
  RENDERINGS_SIGNUP_BANNER = 'web-renderings-signup-banner',
  PROPERTY_DETAILS = 'web-property-details',
  JOB_SHARING_MVP = 'job-sharing-mvps',
  PROPERTY_DETAILS_PHOTOS_TAB = 'web-property-details-photos-tab',
  PAINT_MEASUREMENTS = 'GPAR-paint-measurement-report',
  ONBOARDING_P1_LOGIN = 'web-onboarding-phase-one-log-in',
  ONBOARDING_P1_SIGN_UP = 'web-onboarding-phase-one-sign-up',
  RESKINNED_SIGNUP = 'web-reskinned-signup',
  PRO_LANDING_PAGE = 'MEOW-pro-lead-landing-page',
  VIRTUAL_WALKTHROUGH = 'virtual-walkthrough',
  ONBOARDING_PHASE_1_SIGNIN_PASSWORD = 'web-onboarding-phase-one-sign-in-password',
  ONBOARDING_PHASE_1_SIGNUP_PASSWORD = 'web-onboarding-phase-one-sign-up-password',
  ONBOARDING_PHASE_1_SIGNUP_SELF_QUAL = 'web-onboarding-phase-one-sign-up-self-qual',
  PROJECTS_LIST_READY_BADGE = 'web-projects-list-ready-badge',
  WEB_UPLOAD = 'web-upload',
  ANALYTICS_PAGE = 'access-analytics-pages',
  NEW_PROJECT_UI = 'MEOW_new-project-ui-phase-1',
  INSPECTIONS_WEB_VIEWER = 'web-inspection-web-viewer',
}

enum Mobile {}

enum DesignStudio {
  DS_MACHETE_QUALITY = 'DS_macheteQualityTreatment',
  DS_MACHETE_USE_PRODUCTS_LIBRARY_FOR_TEXTURING = 'DS_useProductsLibraryForTexturingTreatment',
  DS_INSPIRE_ME = 'DS_inspire-me',
  DS_DOOR_GROUPS_DEBUGGING = 'design-studio-door-changing-debugging',
}

enum AiDesigner {
  GML_POST_CAPTURE = 'AID_gml-post-capture',
}

enum FeatureTracking {
  RENDERING = 'rendering',
  AI_DESIGNER = 'ai-designer',
  INSPIRE_ME = 'inspire-me',
  HOMEOWNER_APP = 'homeowner-web-app',
  VIRTUAL_WALKTHROUGH = 'virtual-walkthrough',
  LEAD_LANDING_PAGE = 'lead-landing-page',
}

enum Renderings {
  RENDERINGS_FOR_NEW_CONSTRUCTION = 'new-construction-additions',
}

enum NewConstruction {
  MIXING_MATERIALS = 'commerce-mixing-materials',
  CONSTRUCTION_INTERIOR_ESTIMATION = 'construction-interior-estimation',
}

enum Designer {
  START_SCAN = 'web-react-homeowner-start-scan',
  CUSTOMIZE_MATERIAL_REGIONS = 'web-react-customize-material-regions',
  GOOGLE_LENS = 'web-react-homeowner-google-lens',
  ENABLED_3D_FUSION = 'MEOW_3D_Fusion',
  MATERIAL_CALLOUTS = 'web-react-material-callouts',
  PRODUCT_CATALOG_PROMPTS = 'MEOW_product_catalog_prompts',
}

const Value = {
  CONTROL: 'control',
  OFF: 'off',
  ON: 'on',
} as const;

const localhostFeaturesKey = 'local-split-features';

export type StyleGridPagination = {
  pageSize: number;
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
type Value = (typeof Value)[keyof typeof Value];

type FeatureFlag =
  | DesignStudio
  | Renderings
  | Web
  | AiDesigner
  | Designer
  | NewConstruction;

export type { FeatureFlag };
export {
  DesignStudio,
  Renderings,
  Mobile,
  Value,
  Web,
  localhostFeaturesKey,
  FeatureTracking,
  AiDesigner,
  Designer,
  NewConstruction,
};
